import { HttpBasicRequest } from 'app/shared/models/http-basic-request.model';
import { ContactTypeEnum } from '../enum/contact-type.enum.model';

import { ContactList, ContactVM } from '../models/back-office-admin-common/contact.models';
import { ICompanyForm, CustomerCheckinVM } from '../models/back-office-admin-common/customer-check-in.model';
import { LocationFullDTO } from '../../../shared/models/location.model';
import { ContactMapper } from './contact-mapper';
import { AgencyDto } from 'app/shared/models/agency.model';
import { AgencyVM, AgencyListItemVM, AgencyRegisterDto, RegisterAgencyVM } from '../models/salesNetwork/agency.model';
import { CustomerCategoryDTO } from 'app/shared/models/customer-category.model';
import { AgencyStoreDto, AgencyStoreVm } from 'app/shared/models/agency-store.model';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';

export class AgencyMapper {


  public static AgencyDetail(agency: AgencyDto, location: LocationFullDTO, contacts: ContactVM[], agencyForms: ICompanyForm[], agencyCategories: CustomerCategoryDTO[]) {
    const agencyList: AgencyVM = new AgencyVM({
      agencyCategories,
      agencyCategoriesSelected: null,
      agencyForms,
      // code: agency.code,
      storeActivations: agency.storeActivations,
      checkInStatus: agency.checkInStatus,
      lastModificationTime: agency.lastModificationTime,
      creationTime: agency.creationTime,
      companyFormId: agency.companyFormId,
      externalId: agency.externalId,
      fiscalCode: agency.fiscalCode,
      locationId: agency.locationId,
      name: agency.name,
      vatNumber: agency.vatNumber,
      id: agency.id,
      location,
      contactList: contacts,
      // contactList: ContactMapper.mapContact(contacts),
      creatorId: agency.creatorId,
      lastModifierId: agency.lastModifierId,
      checkInMessage: agency.checkInMessage
    });
    return agencyList;
  }

  public static AgencyListItemVM(agency: AgencyDto, checked?: boolean, agencyStore?: AgencyStoreDto): AgencyListItemVM {
    return new AgencyListItemVM({
      checkInStatus: agency.checkInStatus,
      code: agencyStore?.agencyCode ?? '',
      agencyStoreId: agencyStore?.id ?? null,
      storeActivations: agency.storeActivations,
      vatNumber: agency.vatNumber,
      companyFormId: agency.companyFormId,
      id: agency.id,
      name: agency.name,
      fiscalCode: agency.fiscalCode,
      fullName: `${agencyStore?.agencyCode ?? ''} - ${agency.name}`,
      locationId: agency.locationId,
      locationCity: agency?.location?.city,
      checked: checked,
      checkInMessage: agency.checkInMessage
    });
  }

  public static agencyDTO(agency: AgencyVM) {
    const agencyDTO: AgencyDto = {
      lastModificationTime: agency.lastModificationTime,
      checkInStatus: agency.checkInStatus,
      storeActivations: agency.storeActivations,
      companyFormId: agency.companyFormId,
      externalId: agency.externalId,
      fiscalCode: agency.fiscalCode,
      id: agency.id,
      locationId: agency.locationId,
      name: agency.name,
      vatNumber: agency.vatNumber,
      creationTime: agency.creationTime,
      creatorId: agency.creatorId,
      lastModifierId: agency.lastModifierId,
      checkInMessage: agency.checkInMessage
    };
    return agencyDTO;
  }


  public static ContactList(contacts: ContactVM[]): ContactList {
    const contactList = new ContactList();
    contacts.forEach(element => {
      switch (element.type) {
        case ContactTypeEnum.pec:
        case ContactTypeEnum.administrativeEmail:
        case ContactTypeEnum.commercialEmail:
        case ContactTypeEnum.email:
          contactList.email.push(element);
          break;
        case ContactTypeEnum.mobile:
        case ContactTypeEnum.phone:
        case ContactTypeEnum.fax:
          contactList.phoneNumber.push(element);
          break;
        case ContactTypeEnum.webSite:
          contactList.webSite.push(element);
          break;
        case ContactTypeEnum.instagram:
        case ContactTypeEnum.facebook:
        case ContactTypeEnum.linkedIn:
        case ContactTypeEnum.twitter:
          contactList.social.push(element);
          break;
        default:
          break;
      }
    });
    return contactList;
  }

  public static agencyDTOFromCheckIn(agency: CustomerCheckinVM) {
    const agencyDTO: AgencyRegisterDto = {
      checkInStatus: agency.companyInfo.checkInStatus,
      companyFormId: agency.companyInfo.companyFormId,
      externalId: agency.companyInfo.externalId,
      fiscalCode: agency.companyInfo.fiscalCode,
      locationId: agency.companyInfo.location.id,
      name: agency.companyInfo.name,
      vatNumber: agency.companyInfo.vatNumber,
    };
    return agencyDTO;
  }

  public static RegisterAgencyMap(agencyVM: CustomerCheckinVM): RegisterAgencyVM {

    // var contacts: ContactVM[] = [];
    // contacts = [...contacts, ...agencyVM.contactInfo.email];
    // contacts = [...contacts, ...agencyVM.contactInfo.phoneNumber];
    // contacts = [...contacts, ...agencyVM.contactInfo.social];
    // contacts = [...contacts, ...agencyVM.contactInfo.webSite];
    var contacts: ContactVM[] = agencyVM.contactInfo;

    return new RegisterAgencyVM({
      agency: this.agencyDTOFromCheckIn(agencyVM),
      contacts: contacts,
      location: agencyVM.companyInfo.location
    });
  }

  // public static RegisterAgencyMap(agencyVM: CustomerCheckinVM): RegisterAgencyVM {

  //   var contacts: ContactVM[] = agencyVM.contactInfo;

  //   return new RegisterAgencyVM({
  //     agency: this.agencyDTOFromCheckIn(agencyVM),
  //     contacts: contacts,
  //     location: agencyVM.companyInfo.location
  //   });
  // }

  public static agencyInfoCreateRequest(agencyInfo: AgencyDto, baseUrl: string): HttpBasicRequest[] {
    const result: HttpBasicRequest[] = [];
    result.push({ url: `${baseUrl}/agencies`, method: 'post', body: agencyInfo });
    return result;
  }

  public static UpdateOrAssociateAgencyStore(agencyStore: AgencyStoreVm[], agencyStoreCache: AgencyStoreVm[], baseUrl: string) {
    let result: HttpBasicRequest[] = [];

    agencyStore.filter(x => x.agencyCode && x.isActive && !x.id?.toString()).forEach(element => {
      result.push({
        url: `${baseUrl}/agencies/${element.agencyId}/store`, method: 'post', body: {
          agencyCode: element.agencyCode,
          isActive: element.isActive,
          storeId: element.storeId
        }
      });
    });

    agencyStore.filter(x => x.id?.toString()).forEach(element => {
      let agencyStoreCacheItem = agencyStoreCache.find(x => x.id === element.id);

      if (!UtilityFunctions.isEquals(agencyStoreCacheItem, element)) {
        result.push({
          url: `${baseUrl}/agencies/${element.agencyId}/store/${element.storeId}`, method: 'put', body: {
            agencyCode: element.agencyCode || agencyStoreCacheItem?.agencyCode,
            isActive: element.isActive,
          }
        });
      }
    });
    return result;
  }

}
